module.exports = __webpack_public_path__ + "static/media/quiz2.de5faaf1.png";